export default {
  'cashflowForecasting.header': 'Cash Flow Forecasting'
};
